<template>
    <div style="height: 0px">
        <div
            v-if="visible"
            class="smart-hover-popover"
            :style="popoverStyle"
            @mouseenter="handlePopoverMouseEnter"
            @mouseleave="handlePopoverMouseLeave"
        >
            <div class="smart-hover-actions">
                <!-- Otomasyon Linki Aksiyonları -->
                <template v-if="detectedType === 'automation-webhook'">
                    <div class="action-header">
                        <i class="material-icons">link</i>
                        <span class="action-title">
                            {{
                                detectedData && detectedData.automation
                                    ? detectedData.automation.name
                                    : $t("message.automationLink")
                            }}
                        </span>
                    </div>
                    <div class="action-buttons">
                        <button class="action-btn primary" @click="goToAutomation">
                            <i class="material-icons">open_in_new</i>
                            <span>{{ $t("message.goToAutomation") }}</span>
                        </button>
                        <button class="action-btn" @click="copyToClipboard">
                            <i class="material-icons">content_copy</i>
                            <span>{{ $t("message.copyUrl") }}</span>
                        </button>
                    </div>
                </template>

                <!-- Telefon Numarası Aksiyonları -->
                <template v-if="detectedType === 'phone'">
                    <div class="action-header">
                        <i class="material-icons">phone</i>
                        <span class="action-title">{{ detectedContent }}</span>
                    </div>
                    <div class="action-buttons">
                        <button class="action-btn ai-call" @click="startAiCall" v-if="hasAiVoiceAgentPermission">
                            <i class="material-icons">smart_toy</i>
                            <span>{{ $t("message.callWithAi") }}</span>
                        </button>
                        <button class="action-btn webphone-call" @click="startWebphoneCall">
                            <i class="material-icons">phone_in_talk</i>
                            <span>{{ $t("message.callWithWebphone") }}</span>
                        </button>
                        <button class="action-btn whatsapp" @click="startWhatsappChat" v-if="hasWhatsappChannel">
                            <i class="material-icons">chat</i>
                            <span>{{ $t("message.writeOnWhatsapp") }}</span>
                        </button>
                        <button class="action-btn" @click="copyToClipboard">
                            <i class="material-icons">content_copy</i>
                            <span>Kopyala</span>
                        </button>
                    </div>
                </template>

                <!-- E-posta Aksiyonları -->
                <template v-if="detectedType === 'email'">
                    <div class="action-header">
                        <i class="material-icons">email</i>
                        <span class="action-title">{{ detectedContent }}</span>
                    </div>
                    <div class="action-buttons">
                        <button class="action-btn primary" @click="sendSupsisMail">
                            <i class="material-icons">send</i>
                            <span>Mail Gönder (Supsis ile)</span>
                        </button>
                        <button class="action-btn" @click="openMailTo">
                            <i class="material-icons">open_in_new</i>
                            <span>Mail Gönder (Mail Uygulaması)</span>
                        </button>
                        <button class="action-btn" @click="copyToClipboard">
                            <i class="material-icons">content_copy</i>
                            <span>Kopyala</span>
                        </button>
                    </div>
                </template>
            </div>
        </div>

        <!-- WhatsApp Chat Starter Modal -->
        <Modal2
            v-if="showWhatsappModal"
            :show-footer="false"
            class="modal-wp-chat-starter"
            title="WhatsApp Sohbet Başlat"
            @cancel="closeWhatsappModal"
        >
            <WhatsappChatStarter
                :default-phone-number="whatsappPhoneNumber"
                channel-override
                phone-number-override
                @close="closeWhatsappModal"
            />
        </Modal2>

        <!-- AI Voice Agent Call Starter - görünmez, sadece ref için -->
        <AiVoiceAgentCallStarter
            ref="aiCallStarter"
            :contact="aiCallContact"
            :default-to-number="aiCallPhoneNumber"
            :hide-button="true"
            @close="closeAiCallModal"
        />
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import SYSTEM_PUBSUB from "../utils/systemPubSub";
import Modal2 from "./common/Modal2.vue";
import WhatsappChatStarter from "../views/Pages/Integrations/meta-leads/WhatsappChatStarter.vue";
import AiVoiceAgentCallStarter from "./AiVoiceAgentCallStarter.vue";
import _ from "lodash";
export default {
    name: "SmartHoverActions",
    components: {
        Modal2,
        WhatsappChatStarter,
        AiVoiceAgentCallStarter,
    },
    data() {
        return {
            visible: false,
            detectedType: null, // 'automation-webhook', 'phone', 'email'
            detectedContent: "",
            detectedData: null,
            mouseX: 0,
            mouseY: 0,
            popoverX: 0,
            popoverY: 0,
            currentElement: null,
            hoverTimeout: null,
            hideTimeout: null,
            popoverWidth: 300,
            popoverHeight: 150,
            isPopoverHovered: false,
            showWhatsappModal: false,
            aiCallContact: {},
            aiCallPhoneNumber: "",
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
            channels: (state) => state.channel.channels,
            automations: (state) => state.automation.automations,
            maskSensitiveInfo: (state) =>
                _.get(state.auth.user, "role.isRoot", false) ? false : state.setting.settings.maskSensitiveInfo,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        popoverStyle() {
            return {
                left: `${this.popoverX}px`,
                top: `${this.popoverY}px`,
            };
        },
        hasWhatsappChannel() {
            return this.channels.some(
                (ch) =>
                    ch.type === "whatsapp-business-api" ||
                    ch.type === "whatsapp-business-api-supsis" ||
                    ch.type === "whatsapp-v1" ||
                    ch.type === "whatsapp-v2" ||
                    ch.type === "whatsapp-unipile" ||
                    ch.type === "whatsapp-qr"
            );
        },
        hasAiVoiceAgentPermission() {
            return this.checkPermission("voice-agent.call");
        },
    },
    mounted() {
        this.bindMouseEvents();
    },
    beforeDestroy() {
        this.unbindMouseEvents();
    },
    methods: {
        bindMouseEvents() {
            document.addEventListener("mousemove", this.handleMouseMove);
        },
        unbindMouseEvents() {
            document.removeEventListener("mousemove", this.handleMouseMove);
        },
        handleMouseMove(event) {
            this.mouseX = event.clientX;
            this.mouseY = event.clientY;

            const element = event.target;

            // Eğer popover'ın kendisindeyse veya modal açıksa, hiçbir şey yapma
            if ((this.$el && this.$el.contains(element)) || this.showWhatsappModal) {
                return;
            }

            // Eğer popover hover ediliyorsa, mouse hareketini yoksay
            if (this.isPopoverHovered) {
                return;
            }

            // Aynı element veya child elementlerindeyse ve popover zaten görünürse, hiçbir şey yapma
            if (this.currentElement && this.visible) {
                // Element veya parent'larından biri current element ise, analiz etme
                let parent = element;
                while (parent) {
                    if (parent === this.currentElement) {
                        return; // Aynı element ailesi, hiçbir şey yapma
                    }
                    parent = parent.parentElement;
                }
            }

            // Tamamen farklı bir elemente geçildi
            if (element !== this.currentElement) {
                this.currentElement = element;

                // Önceki timeout'ları temizle
                if (this.hoverTimeout) {
                    clearTimeout(this.hoverTimeout);
                }

                // Element değiştiğinde popover'ı gizlemek için bekleme süresi ekle
                // Bu süre içinde popover'a mouse giderse kapatma iptal edilir
                if (!this.isPopoverHovered) {
                    if (this.hideTimeout) {
                        clearTimeout(this.hideTimeout);
                    }

                    this.hideTimeout = setTimeout(() => {
                        if (!this.isPopoverHovered) {
                            this.visible = false;
                        }
                    }, 150); // Element dışına çıkınca 150ms bekle
                }

                // Biraz bekle (hassasiyet için)
                this.hoverTimeout = setTimeout(() => {
                    if (!this.isPopoverHovered) {
                        this.analyzeElement(element);
                    }
                }, 1000);
            }
        },
        handlePopoverMouseEnter() {
            this.isPopoverHovered = true;
            // Hide timeout'u iptal et
            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout);
            }
        },
        handlePopoverMouseLeave() {
            this.isPopoverHovered = false;
            // Popover'dan çıkınca hemen gizle
            this.hidePopoverImmediately();
        },
        analyzeElement(element) {
            // Bazı elementlerde çalışmasın (input, textarea, button, vb.)
            const excludedTags = ["BUTTON", "INPUT", "TEXTAREA", "SELECT", "HTML", "BODY"];
            const excludedClasses = ["ant-btn", "supsis-button", "action-btn", "icon-btn"];

            if (excludedTags.includes(element.tagName)) {
                return;
            }

            // Excluded class kontrolü
            const hasExcludedClass = excludedClasses.some((className) => element.classList.contains(className));

            if (hasExcludedClass) {
                return;
            }

            // Büyük container elementlerini ignore et (100px'den yüksek)
            const elementHeight = element.offsetHeight || 0;
            const HEIGHT_THRESHOLD = 100;

            if (elementHeight > HEIGHT_THRESHOLD) {
                return;
            }

            // Element'in text içeriğini al
            const text = this.getElementText(element);

            if (!text || text.trim().length === 0) {
                return;
            }

            // Analiz et
            const automationData = this.detectAutomationWebhook(text);
            if (automationData) {
                this.showPopover("automation-webhook", text, automationData);
                return;
            }

            // Hassas bilgi maskeleme açıksa telefon ve e-posta tespitini ignore et
            if (!this.maskSensitiveInfo) {
                const phone = this.detectPhone(text);
                if (phone) {
                    this.showPopover("phone", phone, { phone });
                    return;
                }

                const email = this.detectEmail(text);
                if (email) {
                    this.showPopover("email", email, { email });
                    return;
                }
            }

            // Hiçbir şey tespit edilmediyse - popover'ı gizleme, sadece return et
            // Çünkü handleMouseMove zaten element değiştiğinde gizliyor
        },
        getElementText(element) {
            // Input veya textarea ise value'sunu al
            if (element.tagName === "INPUT" || element.tagName === "TEXTAREA") {
                return element.value;
            }

            // Diğer elementler için textContent
            return element.textContent || element.innerText || "";
        },
        detectAutomationWebhook(text) {
            // Webhook automation URL pattern: /webhook/automation/{siteId}/{webhookId}
            const webhookPattern = /\/webhook\/automation\/.*/;
            const match = text.match(webhookPattern);
            console.log("detectAutomationWebhook", {
                text,
                match,
            });

            if (match) {
                const url = match[0];

                // URL'den :siteId ve :webhookId'yi çekmek için uygun bir regex kullanalım
                // /webhook/automation/:siteId/:webhookId(/...)?
                const regex = /\/webhook\/automation\/([^\/]+)\/([^\/?]+)/;
                const matchGroups = url.match(regex);

                let siteId = null;
                let webhookId = null;

                if (matchGroups && matchGroups.length >= 3) {
                    siteId = matchGroups[1];
                    webhookId = matchGroups[2];
                }

                // Automation listesinden eşleşeni bul
                const automation = this.automations.find((a) => {
                    const automationWebhookId = this.$_.get(a, "options.webhook.id");
                    return automationWebhookId === webhookId;
                });
                console.log("detectAutomationWebhook (complex url)", {
                    text,
                    siteId,
                    webhookId,
                    automation,
                    url: match[0],
                });

                return {
                    siteId,
                    webhookId,
                    automation,
                    url: match[0],
                };
            }

            return null;
        },
        detectPhone(text) {
            // Türkiye ve uluslararası telefon formatları
            const phonePatterns = [
                /(\+?\d{1,3}[\s-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{2}[\s.-]?\d{2}/g, // +90 555 123 45 67
                /(\+?\d{1,3}[\s-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/g, // +1 555 123 4567
                /\+\d{10,15}/g, // +905551234567
            ];

            for (const pattern of phonePatterns) {
                const match = text.match(pattern);
                if (match && match[0]) {
                    // Telefon numarasını temizle
                    const cleanPhone = match[0].replace(/[\s\-\(\)]/g, "");
                    // En az 10 haneli olmalı
                    if (cleanPhone.length >= 10) {
                        return match[0].trim();
                    }
                }
            }

            return null;
        },
        detectEmail(text) {
            // E-posta regex
            const emailPattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
            const match = text.match(emailPattern);

            if (match && match[0]) {
                return match[0].trim();
            }

            return null;
        },
        calculatePopoverPosition() {
            const padding = 10;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;

            let left = this.mouseX + 15;
            let top = this.mouseY + 15;

            // Sağ kenara taşmasını engelle
            if (left + this.popoverWidth > windowWidth - padding) {
                left = this.mouseX - this.popoverWidth - 15;
            }

            // Alt kenara taşmasını engelle
            if (top + this.popoverHeight > windowHeight - padding) {
                top = this.mouseY - this.popoverHeight - 15;
            }

            // Sol kenara taşmasını engelle
            if (left < padding) {
                left = padding;
            }

            // Üst kenara taşmasını engelle
            if (top < padding) {
                top = padding;
            }

            this.popoverX = left;
            this.popoverY = top;
        },
        showPopover(type, content, data) {
            // Eğer aynı tip ve içerikle zaten gösteriliyorsa, hiçbir şey yapma
            if (this.visible && this.detectedType === type && this.detectedContent === content) {
                return;
            }

            this.detectedType = type;
            this.detectedContent = content;
            this.detectedData = data;

            // Popover pozisyonunu hesapla ve sabitle
            this.calculatePopoverPosition();

            this.visible = true;

            // Hide timeout'u temizle
            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout);
            }
        },
        hidePopoverImmediately() {
            this.visible = false;
            this.detectedType = null;
            this.detectedContent = "";
            this.detectedData = null;
            this.currentElement = null;
            this.isPopoverHovered = false;

            // Timeout'ları temizle
            if (this.hoverTimeout) {
                clearTimeout(this.hoverTimeout);
            }
            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout);
            }
        },
        // Aksiyon metodları
        goToAutomation() {
            if (this.detectedData && this.detectedData.automation) {
                // Yeni sekmede aç
                window.open(`/automations/${this.detectedData.automation._id}/design`, '_blank');
            } else if (this.detectedData && this.detectedData.webhookId) {
                // Automation bulunamadıysa ama webhook ID varsa, automation listesine git (yeni sekmede)
                window.open(`/automations`, '_blank');
                this.$message.info("Automation bulunamadı, automation listesine yönlendiriliyorsunuz");
            }
            this.hidePopoverImmediately();
        },
        startAiCall() {
            if (!this.detectedData || !this.detectedData.phone) return;

            const phoneNumber = this.detectedData.phone;

            // Contact objesi oluştur (AiVoiceAgentCallStarter için gerekli)
            this.aiCallContact = {
                phone: phoneNumber,
                fullname: "Bilinmeyen",
                _id: null,
            };

            this.aiCallPhoneNumber = phoneNumber;

            // Popover'ı gizle
            this.hidePopoverImmediately();

            // Bir sonraki tick'te modal'ı aç
            this.$nextTick(() => {
                if (this.$refs.aiCallStarter) {
                    this.$refs.aiCallStarter.showModal();
                }
            });
        },
        closeAiCallModal() {
            // Modal kapandığında contact bilgilerini temizle
            this.aiCallContact = {};
            this.aiCallPhoneNumber = "";
        },
        startWebphoneCall() {
            if (!this.detectedData || !this.detectedData.phone) return;

            const phoneNumber = this.detectedData.phone;

            // Webphone'a arama başlatma event'i gönder
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.WEBPHONE_CALL_START, {
                phoneNumber: phoneNumber,
                contactName: "Bilinmeyen",
            });

            this.$message.success(`Webphone ile ${phoneNumber} aranıyor...`);
            this.hidePopoverImmediately();
        },
        startWhatsappChat() {
            if (!this.detectedData || !this.detectedData.phone) return;

            // Modal'ı göster
            this.whatsappPhoneNumber = this.detectedData.phone;
            this.showWhatsappModal = true;
            this.hidePopoverImmediately();
        },
        closeWhatsappModal() {
            this.whatsappPhoneNumber = "";
            this.showWhatsappModal = false;
        },
        sendSupsisMail() {
            if (!this.detectedData || !this.detectedData.email) return;

            const email = this.detectedData.email;

            // Mail sayfasına yönlendir
            this.$router.push({
                path: "/mails",
                query: {
                    action: "create",
                    to: email,
                },
            });

            this.hidePopoverImmediately();
        },
        openMailTo() {
            if (!this.detectedData || !this.detectedData.email) return;

            const email = this.detectedData.email;
            window.location.href = `mailto:${email}`;
            this.hidePopoverImmediately();
        },
        copyToClipboard() {
            const textToCopy = this.detectedContent;

            if (!textToCopy) return;

            const input = document.createElement("input");
            input.value = textToCopy;
            document.body.appendChild(input);
            input.select();
            document.execCommand("copy");
            document.body.removeChild(input);

            this.$message.success("Panoya kopyalandı");
            this.hidePopoverImmediately();
        },
    },
};
</script>

<style lang="scss" scoped>
.smart-hover-popover {
    position: fixed;
    z-index: 99999;
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    min-width: 250px;
    max-width: 350px;
    animation: fadeInScale 0.2s ease;
    border: 1px solid #e5e7eb;
    pointer-events: all;
    user-select: none;

    @keyframes fadeInScale {
        from {
            opacity: 0;
            transform: scale(0.95);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    .smart-hover-actions {
        .action-header {
            padding: 12px 16px;
            background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
            display: flex;
            align-items: center;
            gap: 8px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);

            .material-icons {
                font-size: 20px;
                color: white;
            }

            .action-title {
                color: white;
                font-weight: 600;
                font-size: 14px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                flex: 1;
            }
        }

        .action-buttons {
            padding: 8px;
            display: flex;
            flex-direction: column;
            gap: 6px;

            .action-btn {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 10px 12px;
                border: 1px solid #e5e7eb;
                background: white;
                border-radius: 8px;
                cursor: pointer;
                transition: all 0.2s ease;
                font-size: 13px;
                font-weight: 500;
                color: #4b5563;
                width: 100%;
                text-align: left;

                .material-icons {
                    font-size: 18px;
                    color: #6b7280;
                    transition: all 0.2s ease;
                }

                span {
                    flex: 1;
                }

                &:active {
                    transform: translateY(0);
                }

                &:hover {
                    background: #f9fafb;
                    border-color: #6366f1;
                    color: #6366f1;
                    transform: translateY(-1px);
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

                    .material-icons {
                        color: #6366f1;
                    }
                }

                &.primary {
                    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
                    color: white;
                    border: none;

                    .material-icons {
                        color: white;
                    }

                    &:hover {
                        background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
                        box-shadow: 0 4px 8px rgba(99, 102, 241, 0.3);
                    }
                }

                &.ai-call {
                    background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);
                    color: white;
                    border: none;

                    .material-icons {
                        color: white;
                    }

                    &:hover {
                        background: linear-gradient(135deg, #d97706 0%, #ea580c 100%);
                        box-shadow: 0 4px 8px rgba(245, 158, 11, 0.3);
                    }
                }

                &.webphone-call {
                    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
                    color: white;
                    border: none;

                    .material-icons {
                        color: white;
                    }

                    &:hover {
                        background: linear-gradient(135deg, #059669 0%, #047857 100%);
                        box-shadow: 0 4px 8px rgba(16, 185, 129, 0.3);
                    }
                }

                &.whatsapp {
                    background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
                    color: white;
                    border: none;

                    .material-icons {
                        color: white;
                    }

                    &:hover {
                        background: linear-gradient(135deg, #128c7e 0%, #075e54 100%);
                        box-shadow: 0 4px 8px rgba(37, 211, 102, 0.3);
                    }
                }
            }
        }
    }
}

// Dark mode support
.dark-mode {
    .smart-hover-popover {
        background: #1f2937;
        border-color: #374151;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3), 0 2px 8px rgba(0, 0, 0, 0.2);

        .smart-hover-actions {
            .action-buttons {
                .action-btn {
                    background: #374151;
                    border-color: #4b5563;
                    color: #e5e7eb;

                    .material-icons {
                        color: #9ca3af;
                    }

                    &:hover {
                        background: #4b5563;
                        border-color: #818cf8;
                        color: #818cf8;

                        .material-icons {
                            color: #818cf8;
                        }
                    }
                }
            }
        }
    }
}
</style>
